<div class="map-item-link">
    <a
        tabindex=0
        class="map-item-link__label"
        (click)="triggerMapItem($event)"
        (keydown.enter)="triggerMapItem($event)"
        (keydown.space)="triggerMapItem($event)"
    >
        {{ label }}
    </a>
</div>
